import classNames from 'classnames';
import { ControlProps, TextInput, TextInputProps } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './TextInputDecorator.css';

export type TextInputDecoratorProps = TextInputProps &
    ControlProps & {
        valid?: boolean;
        cls?: string;
        getSuggestCallback?: (onSuccess: (items: string[]) => void) => void;
        getBlurFunc?: (blur: () => void) => void;
    };

export class TextInputDecorator extends React.PureComponent<TextInputDecoratorProps & ControlProps> {
    public static defaultProps = {
        valid: true
    };

    public textInput: TextInput | null;

    constructor(props: TextInputDecoratorProps) {
        super(props);

        if (this.props.getBlurFunc) {
            this.props.getBlurFunc(() => {
                this.blur();
            });
        }
    }

    componentDidMount() {
        if (this.props.autoFocus) {
            this.focus();
        }
    }

    focus() {
        const { text = '' } = this.props;

        // Дефолтное поведение инпута со значением при фокусе - устанавливать курсор в начало.
        // Здесь переводится курсор в инпуте в конец
        if (this.textInput) {
            // https://st.yandex-team.ru/ISL-5067 - ждем когда все это приедет в тайпинги с нормальным innerRef
            const { _control } = this.textInput;
            const textLength = String(text).length;

            _control.setSelectionRange(textLength, textLength);
            _control.focus();
        }
    }

    blur() {
        if (this.textInput) {
            const { _control } = this.textInput;
            _control.blur();
        }
    }

    render() {
        const { cls, valid, ...passThroughProps } = this.props;

        if (passThroughProps.iconLeft) {
            passThroughProps.iconLeft = (
                <span className={Bem.cls('textinput-decorator', 'left-icon')}>{passThroughProps.iconLeft}</span>
            );
        }

        if (passThroughProps.iconRight) {
            passThroughProps.iconRight = (
                <span className={Bem.cls('textinput-decorator', 'right-icon')}>{passThroughProps.iconRight}</span>
            );
        }

        return (
            <div className={classNames(Bem.cls('textinput-decorator'), cls)}>
                <TextInput
                    {...passThroughProps}
                    cls={Bem.cls({
                        block: 'textinput-decorator',
                        elem: 'input',
                        mods: {
                            valid: valid ? 'yes' : 'no',
                            'has-left-icon': Boolean(passThroughProps.iconLeft),
                            'has-right-icon': Boolean(passThroughProps.iconRight)
                        }
                    })}
                    dataprovider={this.addressProvider}
                    ref={this.setRef}
                />
            </div>
        );
    }

    private setRef = (node: TextInput) => {
        this.textInput = node;
    };

    /**
     * lego TextInput provider, несет в себе callback обновления списка элементов саджеста
     */
    private addressProvider = (suggestUrl: string, val: string, onSuccess: (items: string[]) => void) => {
        const { suggest, getSuggestCallback } = this.props;

        if (getSuggestCallback && suggest) {
            getSuggestCallback(onSuccess);
        }
    };
}
